<template>
    <div class="com_head_tool_bar">
        <!-- tabbar 顶部logo和钱包组件 -->
        <div class="tool_bar_left">
            <!-- <img class="tool_bar_logo" :src="logoUrl" alt=""> -->
            <div class="tool_bar_title">{{ logoUrl || 'GGC' }}</div>
        </div>
        <div class="com_head_tool_bar_right">
            <img class="tool_bar_operation" :src="operationIcon" alt="" @click="operationClick">
            <div class="com_head_tool_bar_right_wallet">
                <img :src="walletIcon" alt="" v-if="walletIcon">
                <span>{{ address }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ComHeadToolBar',
    props: {
        logoUrl: {
            type: String,
            default: ''
        },
        walletAddress: {
            type: String,
            default: ''
        },
        walletIcon: {
            type: String,
            default: ''
        },
        operationIcon: {
            type: String,
            default: ''
        },
    },
    computed: {
        address() {
            return this.walletAddress.slice(0, 4) + '...' + this.walletAddress.slice(-4)
        }
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        operationClick() {
            this.$emit('operationClick')
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
